import { render } from "./Select.vue?vue&type=template&id=376403fa"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=376403fa&lang=css"
script.render = render

export default script